// export BASE_URL 
// export const baseUrl = import.meta.env.VITE_PWA_BASE_URL;
export const baseUrl = "https://remind.thoughtlinetech.com/api";

// export COMPANY_ID
export const companyId = 18;
// export const companyId = import.meta.env.VITE_PWA_COMPANY_ID;

export const getApiColours = (endpoint: string) => `${baseUrl}/companies/${companyId}/${endpoint}`;

export const getApiLogos = (endpoint: string) => `${baseUrl}/companies/${companyId}/${endpoint}`;

export const getApiSlides = (endpoint: string) => `${baseUrl}/companies/${companyId}/${endpoint}`;

export const getApiEmails = (endpoint: string) => `${baseUrl}/${endpoint}`;